import { InjectionToken } from '@angular/core';
import { AppSettings, defaults } from '@ukam/shell/config';

// Configurações padrão (tema, logo, ...) de cada aplicação. Cada app informa
// só o que a distingue (ex.: logoDark/logoLight); o resto herda de `defaults`.
export const APP_SETTINGS_DEFAULTS = new InjectionToken<AppSettings>('APP_SETTINGS_DEFAULTS', {
  providedIn: 'root',
  factory: () => defaults,
});
